module.exports = __webpack_public_path__ + "static/media/office-girl.ac185975.svg";